import { FlexCell, Panel } from '@epam/promo';
import { useQuery } from '@tanstack/react-query';
import { useRef } from 'react';

import { getAdmins } from 'api/admin.service';
import { PermissionCard, PermissionForm } from 'components/permissions';
import { useScroll } from 'hooks';
import { User } from 'models/user.model';
import { usePermissionStore } from 'store/permission';
import { useUserStore } from 'store/user';
import css from './PermissionPage.module.scss';

export const PermissionPage = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const currentUser = useUserStore((state) => state.user);
  const { isLoading, data: admins } = useQuery({
    queryKey: ['admins'],
    queryFn: getAdmins,
    select: (data: User[]) => {
      usePermissionStore.setState({
        admins: data.map((admin) => admin.email),
      });

      return data;
    },
  });
  const { isScrollable } = useScroll(containerRef, [admins?.length]);

  if (!currentUser) {
    return null;
  }

  if (!admins?.length) {
    return (
      <Panel
        shadow
        background="white"
        cx={{
          [css.page__panel]: true,
          'skeleton-loader': isLoading,
        }}>
        <FlexCell>
          <PermissionForm />
        </FlexCell>
        <FlexCell cx={css['page__gutter-top']}>
          <PermissionCard user={currentUser} />
        </FlexCell>
      </Panel>
    );
  }

  return (
    <Panel
      shadow
      background="white"
      cx={{
        [css.page__panel]: true,
        [css['page__no-gutter']]: admins.length >= 5,
        'skeleton-loader': isLoading,
      }}>
      <FlexCell>
        <PermissionForm />
      </FlexCell>
      <FlexCell
        ref={containerRef}
        cx={{
          [css['page__user-list']]: true,
          [css['page__gutter-top']]: true,
          [css.page__gradient]: isScrollable,
        }}>
        {[currentUser, ...admins].map((admin) => (
          <PermissionCard key={admin.id} user={admin} />
        ))}
      </FlexCell>
    </Panel>
  );
};
